import { css } from '@emotion/css';

import { RadioSize } from './types';

const radioFontSize = {
  large: 2.4,
  medium: 2.0,
  small: 1.8,
  'x-small': 1.6,
};

export const radioOverrides = css`
  &.MuiRadio-root {
    background-color: var(--transparent) !important;
  }

  &.MuiRadio-root:active {
    .outer-circle {
      border-color: var(--focus-primary);
    }
  }

  &.MuiRadio-root.Mui-checked:active {
    .outer-circle {
      border-color: var(--interactive-primary-active);
    }
    .inner-circle {
      background-color: var(--interactive-primary-active);
    }
  }
`;

export const radioIcon = (size: RadioSize) => css`
  width: ${radioFontSize[size]}rem;
  height: ${radioFontSize[size]}rem;
  .inner-circle {
    width: ${radioFontSize[size] / 2}rem;
    height: ${radioFontSize[size] / 2}rem;
  }
`;
